// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 21003-反馈详情 查询反馈详情和处理进度 GET /app/v1/complaint/detail/${param0} */
export async function getComplaintDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getComplaintDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimComplaintDetailAppVo>(
    `/app/v1/complaint/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 21002-反馈列表 查询用户反馈列表 POST /app/v1/complaint/list */
export async function getComplaintList(
  body: API.SwimComplaintListAppQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimComplaintListAppVo>(
    "/app/v1/complaint/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 21001-提交反馈 用户提交反馈建议 POST /app/v1/complaint/submit */
export async function submitComplaint(
  body: API.SwimComplaintSubmitAppVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOLong>("/app/v1/complaint/submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
